import type { IconLookup } from '@fortawesome/fontawesome-common-types'

import { setup } from './setup'

setup()

export * from './FontAwesome'

export function findIconDefinition(iconLookup: IconLookup): IconLookup {
  return iconLookup
}
